// src/features/auth/components/RewardsList.tsx
import "../auth.css";
import { motion, AnimatePresence } from "framer-motion";
import type { RewardItem } from "../auth.types";
import RewardRow from "./RewardRow";

const listVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.07, delayChildren: 0.1 },
  },
};

interface RewardsListProps {
  rewards: RewardItem[];
  isLoading?: boolean;
  className?: string;
}

const RewardsList = ({
  rewards,
  isLoading = false,
  className = "",
}: RewardsListProps) => {
  // Loading skeleton — 3 placeholder rows while awaiting API
  if (isLoading) {
    return (
      <div className={`flex flex-col gap-[2px] mb-6 ${className}`}>
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={i}
            className="h-[48px] rounded-lg bg-white/5 animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (!rewards.length) return null;

  return (
    <AnimatePresence>
      <motion.div
        className={`flex flex-col gap-[2px] mb-6 max-h-[260px] overflow-y-auto overflow-x-hidden pr-1 scrollbar-2 ${className}`}
        variants={listVariants}
        initial="hidden"
        animate="visible"
      >
        {rewards.map((item) => (
          <RewardRow key={item.id} item={item} />
        ))}
      </motion.div>
    </AnimatePresence>
  );
};

export default RewardsList;
